import mitt, { EventType } from "mitt";

interface Events extends Record<EventType, unknown> {
  "@incidents:updated": string;
}

const incidentsEvents = mitt<Events>();

export { incidentsEvents };
